import React from 'react';
import { Pill } from '@/components/shared/badges';

export function TrialCountdown({ isTrial, expiresAt }: { isTrial?: boolean; expiresAt?: string | null }) {
  if (!isTrial) return null;
  const deadline = expiresAt ? Date.parse(expiresAt) : NaN;
  const remaining = deadline - Date.now();
  const days = Math.ceil(remaining / 86_400_000);
  const expired = Number.isFinite(deadline) && remaining <= 0;
  const label = !Number.isFinite(deadline)
    ? 'On trial · deadline not reported'
    : expired ? 'Trial expired' : `On trial · ${days} day${days === 1 ? '' : 's'} left`;
  return (
    <Pill bg={expired ? 'var(--ps-pill-red-bg)' : 'var(--ps-pill-green-bg)'} fg={expired ? 'var(--ps-pill-red-tx)' : 'var(--ps-pill-green-tx)'}>
      {label}
    </Pill>
  );
}
